import bindAllMethods from '../../../utils/bindAllMethods';
import {
  GetProviderListParam,
  GetProviderListResponseType,
  IProviderClient
} from '../../../clients/shell/provider';
import ILoginService from './ILoginService';
import { GenerateAuthenticationUrlParams } from './types';
import { SetServiceDependencies } from '../../../infra/startup/types';
import { Stack } from '../../../core/types/stratus';
import StateParamHandlerService from '../../../services/stateParamHandlerService/StateParamHandlerService';
import {
  AuthorizationUrlBuilder,
  IAuthorizationUrlBuilder
} from './AuthorizationUrlBuilder';
import BaseLoginService from './BaseLoginService';

class LoginServiceWeb extends BaseLoginService implements ILoginService {
  private _portalStack: Stack;
  private _providerClient: IProviderClient;
  private _stateParamHandlerService: StateParamHandlerService;
  // TODO check if needs to verify this in somewhere.
  // const { enable } = manifest?.services?.login || {};

  public setDependencies({
    clients,
    services,
    ...rest
  }: SetServiceDependencies): void {
    super.setDependencies({ clients, services, ...rest });
    const { shell } = clients;
    this._providerClient = shell?.providerClient;
    this._portalStack = services.applicationService.getPortalStack();
    this._stateParamHandlerService = services.stateParamHandlerService;
    bindAllMethods(this);
  }

  public async getProviderList(
    options?: GetProviderListParam
  ): Promise<GetProviderListResponseType> {
    return this._providerClient.getProviderList(options);
  }

  public async generateAuthenticationUrl(
    options: GenerateAuthenticationUrlParams
  ): Promise<string> {
    const authorizationUrlBuilder: IAuthorizationUrlBuilder =
      new AuthorizationUrlBuilder(
        options.authorizationUrl,
        this._stateParamHandlerService
      );

    authorizationUrlBuilder
      .withLoginHint()
      .withMaxAgeZeroOnLogin()
      .withAuthorizationExtraParams()
      .withState(options.postLoginRedirect, options.language, options.country)
      .withLocale(options.language, options.country);

    await authorizationUrlBuilder.withVisitorUUID(this._portalStack);
    return authorizationUrlBuilder.build();
  }
}

export default LoginServiceWeb;
